import React, { Fragment } from 'react';

import { withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import { Button, FormLabel, Grid, Tooltip, Typography } from '@material-ui/core';

import { AppState, Actions, store, IPageState } from '../../appredux';

import { connect } from 'react-redux';

import { Trans, WithTranslation, withTranslation, TransProps } from 'react-i18next';

import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
//import {registerLocale} from 'react-datepicker';
//import DateFnsUtils from '@date-io/date-fns';
import moment from "moment";

import MomentUtils from "@date-io/moment";

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

import { setLocale } from '../common/localeHelpers';
import { daysFromDate, datediff, sendErrorLog, formatDate, timeZone } from '../common/helpers';

import FlagIcons from './FlagIcons';
import FlagIconsOld from '../common/flags/FlagIconsOld';
import { bookService, Dostepnosc, dostepnoscPokoju, ObiectRoomNumer } from '../../api';
import { fontSelect } from '../../fonts';
import CONFIG from '../../cfg/config';
import { instanceOf } from 'prop-types';
import { format } from 'date-fns';

import CheckIcon from '@material-ui/icons/Check';
import RemoveIcon from '@mui/icons-material/Remove';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import MeetingRoomIcon from '@mui/icons-material/MeetingRoom';
import MeetingRoomOutlinedIcon from '@mui/icons-material/MeetingRoomOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import PaidIcon from '@mui/icons-material/Paid';
import theme from 'themes/themes';
import { GRAFIK_DNI } from 'App';
import Calendar from './Calendar';

interface DatePickersProp {
  page: IPageState,
  expanded: boolean,
  expand: () => void,
  noFlags?: boolean,
  windowWidth: number
}

type DatePickersState = {
  fromDate: Date,
  toDate: Date,
  openCalendar: boolean
}

class DatePickers extends React.Component<DatePickersProp & WithTranslation & WithStyles<typeof styles> & TransProps, DatePickersState> {
  textTheme = fontSelect(3, 2) as React.CSSProperties;
  //textColor = { color: '#732222' } as React.CSSProperties;

  constructor(props: DatePickersProp & WithTranslation & WithStyles<typeof styles> & TransProps) {
    super(props, {});

    this.state = {
      fromDate: new Date(this.props.page.dateFrom),
      toDate: new Date(this.props.page.dateTo),
      openCalendar: this.props.page.firstOpen && !(CONFIG.rezNr != "" && CONFIG.telNr != "") //jest rezerwacja to brak kalendarza
    }

    store.dispatch(Actions.pageState.setFirstOpen());
  }

  componentDidMount() {
    this.getDetailsForAllRooms(this.props.page.dateFrom, this.props.page.dateFrom);
  }

  async componentDidUpdate(prevProps: DatePickersProp, prevState: DatePickersState) {
    //if(this.props.page.podstrona !==prevProps.page.podstrona ){ //|| this.props.page.roomsOld.length !== prevProps.page.roomsOld.length
    //  await this.getDetailsForAllRooms(this.props.page.dateFrom, this.props.page.dateFrom)
    //}

    if(this.props.page.dateFrom !== formatDate(this.state.fromDate) || this.props.page.dateTo !== formatDate(this.state.toDate)){
      this.setState({
        fromDate: new Date(this.props.page.dateFrom),
        toDate: new Date(this.props.page.dateTo),
      })
    }
    if(this.props.page.refreshCalendar !== prevProps.page.refreshCalendar && this.state.openCalendar){
      this.setState({openCalendar: false})
      setTimeout(() => {
        this.setState({openCalendar: true})
      }, 300);
      
    }

  }


  openCalendar = () => {
    this.setState({ openCalendar: true })
  }

  closeCalendar = () => {
    this.setState({ openCalendar: false })
  }

  acceptCalendar = async (date: any) => {
    let d = date;
    if (d.from == d.to) {
      d.to = daysFromDate(new Date(d.from), 1)
    }

    await this.dateCalendarAccept(date)
    //await this.dateFromAccept(date.from)
    //await this.dateToAccept(date.to)
    this.setState({ openCalendar: false })
  }

  //SW 2021-04-23
  dateCalendarAccept = async (dateParam: any) => {
    let dateFrom = new Date(dateParam.from);
    dateFrom.setHours(2)
    let dateTo = new Date(dateParam.to);
    dateTo.setHours(2)

    let diff = 2
    if (dateFrom.getTime() + 3600 * 24000 > dateTo.getTime()) {
      diff = 2
    } else {
      diff = datediff(dateFrom, dateTo)
    }

    await store.dispatch(Actions.pageState.setDateTo(daysFromDate(dateTo, 0)));
    await store.dispatch(Actions.pageState.setDateFrom(daysFromDate(dateFrom, 0), true));
    await store.dispatch(Actions.pageState.setDateTo(daysFromDate(dateTo, 0)));

    this.getDetailsForAllRooms(formatDate(dateFrom), formatDate(dateFrom));


    this.setState({ fromDate: dateFrom, toDate: new Date(daysFromDate(dateFrom, diff)) });

    //this.setState({toDate: date});
  };




  dateChange = (date: any) => {
    //this.setState({ fromDate: date });
    //this.getDetailsForAllRooms( formatDate(date), formatDate(date) ); // mz 2022-06-13
  };

  dateAccept = (dateParam: any) => {
    let date = new Date(dateParam);

    date.setHours(0);
    date = new Date(new Date(date).getTime() + timeZone(new Date(date)))

    store.dispatch(Actions.pageState.setDateFrom(daysFromDate(date, 0)));
    this.setState({ fromDate: date });
    this.getDetailsForAllRooms( formatDate(date), formatDate(date) ); // mz 2022-06-13
  };

  dateAcceptMonth = (dateParam: any) => {
    let date = new Date(new Date(dateParam).setDate(1));
    date.setHours(0);
    date = new Date(new Date(date).getTime() + timeZone(new Date(date)))

    if (date.getTime() < new Date().getTime()) {
      date = new Date()
    }

    this.setState({ fromDate: date });
    store.dispatch(Actions.pageState.setDateFrom(daysFromDate(date, 0), true));
    this.getDetailsForAllRooms(formatDate(date), formatDate(date)); // mz 2022-06-13
  };

  getDetails = async (aRodzPokoi : number, dataOd : string, dataDo : string): Promise<dostepnoscPokoju | null> => { // mz 2022-06-13
    let ret = null;

    try {

      let res: Dostepnosc
      if(this.props.page.serwerWersja >= 5 && this.props.page.podstrona){
        res = await bookService.dajCenyPodstrona(
          {
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")),
              aRodzPokoiId: aRodzPokoi,
              aPodstronaNr: this.props.page.podstrona,
              aDataOd: dataOd, //this.props.page.dateFrom
              aDataDo: daysFromDate(new Date(dataDo), GRAFIK_DNI + 1)
              //d
          }, {}
        );
        store.dispatch(Actions.pageState.setCeny(res.result, aRodzPokoi))
      } else if(this.props.page.serwerWersja >= 5){
        res = await bookService.dajCeny(
          {
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")),
              aRodzPokoiId: aRodzPokoi,
              aDataOd: dataOd, //this.props.page.dateFrom
              aDataDo: daysFromDate(new Date(dataDo), GRAFIK_DNI + 1)
              //d
          }, {}
        );
        store.dispatch(Actions.pageState.setCeny(res.result, aRodzPokoi))
      } else {
        res = await bookService.dajDostepnosc(
          {
              hotelId: CONFIG.hotelID,
              aOperatorId: Number(sessionStorage.getItem("operator_id")),
              aRodzPokoiId: aRodzPokoi,
              aDataOd: dataOd, //this.props.page.dateFrom
              aDataDo: dataDo, //this.props.page.dateFrom
          }, {}
        );    
      }

        
            
        if (Array.isArray(res.result) && res.result.length) {
            let resDost = res.result[0];

            // let aDataOd = this.props.page.dateFrom // 4 linie testowe, do zakomentowania w produkcji
            // console.log('Data: ' + aDataOd + " " + getDayOfWeekFromDate(aDataOd))
            // if(getDayOfWeekFromDate(aDataOd).includes('sobota') || getDayOfWeekFromDate(aDataOd).includes('niedziela'))
            //     resDost.cena_pokoj += 50;

            //console.log('getDetails - ' + resDost.cena_pokoj)
            ret = resDost;
        }
    } catch (err) {
        await sendErrorLog("0", "-1", 'sprawdzenie dostępności pokoju')
        await store.dispatch(Actions.pageState.addFcmLogMessage("sprawdzenie dostępności pokoju", 2))
        console.log(err);
    }

    return ret;
  }

  getDetailsForAllRooms = (dataOd : string, dataDo : string) => { // mz 2022-06-13
    if (CONFIG.grafikiRodzaj === "0" || CONFIG.grafikiRodzaj === "3"){
      try {
        let list : dostepnoscPokoju[] = [];

        this.props.page.roomsOld.forEach(async (room1, key, arr) => {
          let item = await this.getDetails(room1.www_rodz_pokoi_id, dataOd, dataDo);
          //console.log('getDetails - item - ' + item?.cena_pokoj);

          if(item != null){
            item.pokoj = room1.www_rodz_pokoi_id;
            list.push(item);
          }

          if (Object.is(arr.length - 1, key)){
            await store.dispatch(Actions.pageState.setRoomDetailsList(list));
          }
        });

      } catch (err) {
        sendErrorLog("0", "-1", 'sprawdzenie dostępności pokoju')
        store.dispatch(Actions.pageState.addFcmLogMessage("sprawdzenie dostępności pokoju", 2))
        console.log(err);
      }
    }
  }

  setDateButton = (days: number) => {

    let diff = datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo))
  

    let dateString: string = daysFromDate(new Date(this.props.page.dateFrom), days);
    let dateToString = daysFromDate(new Date(dateString), diff);
    let dateNow = new Date()
    dateNow.setHours(0);
    dateNow.setMinutes(1);

    if (this.props.page.dateFrom == dateString)
      return

    if (dateNow.getTime() < new Date(dateString).getTime()) {
      this.setState({ fromDate: new Date(dateString) });
      store.dispatch(Actions.pageState.setDateFrom(dateString));
      store.dispatch(Actions.pageState.setDateTo(dateToString));

      this.getDetailsForAllRooms(dateString, dateString); // mz 2022-06-13
    } else {
      this.setState({ fromDate: new Date() });
      store.dispatch(Actions.pageState.setDateFrom(daysFromDate(new Date(), 0)));
      store.dispatch(Actions.pageState.setDateTo(daysFromDate(new Date(), diff)));

      this.getDetailsForAllRooms(formatDate(new Date()), formatDate(new Date())); // mz 2022-06-13
    }
  };

  setNextWeek = () => {
    var firstDay = moment(this.props.page.dateFrom).startOf('isoWeek').toDate();
    let dataOd = new Date(daysFromDate(firstDay, 8));

    this.setState({ fromDate: dataOd, });
    store.dispatch(Actions.pageState.setDateFrom(daysFromDate(dataOd, 0)));

    this.getDetailsForAllRooms(formatDate(dataOd), formatDate(dataOd));
  }


  setNextMonth = () => {

    let from = new Date(this.props.page.dateFrom);
  
    if(from.getMonth() === 11){
        from.setFullYear(from.getFullYear() +1)
        from.setMonth(0)
        from.setDate(1)
    } else {
        from.setMonth(from.getMonth() +1)
        from.setDate(1)
    }

    from.setHours(0);
    from = new Date(new Date(from).getTime() + timeZone(new Date(from)))

    this.setState({  fromDate: from, });
    store.dispatch(Actions.pageState.setDateFrom(daysFromDate(from, 0)));
    this.getDetailsForAllRooms(formatDate(from), formatDate(from));
  }

  setLastMonth = () => {

    let from = new Date(this.props.page.dateFrom);
    let dateNow = new Date()

    dateNow.setHours(0);
    dateNow = new Date(new Date(dateNow).getTime() + timeZone(new Date(dateNow)))
  
    if(from.getMonth() === 0){
        from.setFullYear(from.getFullYear() -1)
        from.setMonth(11)
        from.setDate(1)
    } else {
        from.setMonth(from.getMonth() -1)
        from.setDate(1)
    }

    if (dateNow.getTime() > from.getTime()) {
      from = new Date()
    }

    from.setHours(0);
    from = new Date(new Date(from).getTime() + timeZone(new Date(from)))

    this.setState({  fromDate: from, });
    store.dispatch(Actions.pageState.setDateFrom(daysFromDate(from, 0)));
    this.getDetailsForAllRooms(formatDate(from), formatDate(from));
  }

  

  setToday = () => {
    let diff = datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo))

    this.setState({ fromDate: new Date() });

    store.dispatch(Actions.pageState.setDateFrom(daysFromDate(new Date(), 0), true));
    store.dispatch(Actions.pageState.setDateTo(daysFromDate(new Date(), diff)));

    this.getDetailsForAllRooms(formatDate(new Date()), formatDate(new Date())); // mz 2022-06-13
  }

  setGrafikMode = (wersja: number) => {
    store.dispatch(Actions.pageState.setGrafikMode(wersja));
  }

  daysPanel = () => {
    const { classes } = this.props;

    if(this.props.page.podstrona)
      return null
    else
      return (
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="baseline"
        style={{ marginTop: "4px", padding: "0px 5px" }}>
        <Grid item style={{ width: "31%", marginRight: "0px" }} >
          <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} variant="outlined" color="primary" style={this.textTheme}
            onClick={() => this.setDateButton(-1)}>
            {'- 1'}
          </Button>
        </Grid>
        <Grid item style={{ width: "31%", marginRight: "0px" }} >
          <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} variant="outlined" color="primary" style={this.textTheme}
            onClick={() => this.setDateButton(1)}>
            {'+ 1'}
          </Button>
        </Grid>
        {/* <Grid item style={{ width: "31%", marginRight: "2px" }} >
          <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} variant="outlined" color="primary" style={this.textTheme}
            onClick={() => this.setNextWeek()}>
            {'+ 7'}
          </Button>
        </Grid> */}
        {/* <Grid item style={{ width: "25%", marginRight: "0px" }} >
          <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} variant="outlined" color="primary" style={this.textTheme}
            onClick={() => this.setNextMonth()}>
            {'+ 31'}
          </Button>
        </Grid> */}
    </Grid>
    )
  }

  daysPanelMobile = () => {
    const { classes } = this.props;
    let btnStyle = { width: this.props.windowWidth > 600 ? "40px" : "50px", } as React.CSSProperties

    if(this.props.page.podstrona)
      return null
    else
      return (
      <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="baseline"
                style={{ margin: "8px 0px 8px", padding: "0px 5px" }}>
                {/* <Grid item style={{ marginRight: "8px" }} >
                  <Button className={`${classes.button} ${classes.dateBorder} ${classes.primary}`} style={{ ...btnStyle, ...this.textTheme }} variant="outlined" color="primary"
                    onClick={() => this.setDateButton(-31)}>
                    {'- 31'}
                  </Button>
                </Grid>
                <Grid item style={{ marginRight: "8px" }} >
                  <Button className={`${classes.button} ${classes.dateBorder} ${classes.primary}`} style={{ ...btnStyle, ...this.textTheme }} variant="outlined" color="primary"
                    onClick={() => this.setDateButton(-7)}>
                    {'- 7'}
                  </Button>
                </Grid> */}
                <Grid item style={{ marginRight: "8px" }} >
                  <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} style={{ ...btnStyle, ...this.textTheme }} variant="outlined" color="primary"
                    onClick={() => this.setDateButton(-1)}>
                    {'- 1'}
                  </Button>
                </Grid>
                <Grid item style={{ marginRight: "8px" }} >
                  <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} style={{ ...btnStyle, ...this.textTheme }} variant="outlined" color="primary"
                    onClick={() => this.setDateButton(1)}>
                    {'+ 1'}
                  </Button>
                </Grid>
                {/* <Grid item style={{ marginRight: "8px" }} >
                  <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} style={{ ...btnStyle, ...this.textTheme }} variant="outlined" color="primary"
                    onClick={() => this.setNextWeek()}>
                    {'+ 7'}
                  </Button>
                </Grid>  */}
                {/* <Grid item style={{  }} >
                  <Button className={`${classes.button} ${classes.dateBorder} ${classes.orange}`} style={{ ...btnStyle, ...this.textTheme }} variant="outlined" color="primary"
                    onClick={() => this.setNextMonth()}>
                    {'+ 31'}
                  </Button>
                </Grid> */}
              </Grid>
    )
  }

  legend = () => {
    const { classes } = this.props;

    //if(this.props.page.podstrona)
    //  return null
    //else
      return (
        <>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="baseline"
          style={{ marginTop: "10px"  }}>
          <Grid item style={{ marginRight: "3px" }} >
            {/* <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={{ ...btnStyle1, ...this.textTheme }}>
            <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em"}}></CheckIcon>
          </Button> */}
            <Typography component="h6" className={classes.textBorder} style={{ width:"91px" }} color='primary'>
            {this.props.page.serwerWersja >= 5 ?
             <>
             
             {/* <span style={{ fontSize: "12px", marginRight: "3px" }}> 123 </span> */}
             <span style={{ fontSize: "12px", textTransform: "lowercase" }}> <Trans>Prices</Trans> </span>
             </>
            :
            <>
              <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px", marginRight: "3px" }}></CheckIcon>
              <span style={{ fontSize: "12px" }}> <Trans>Wolny</Trans> </span>
              </>
            }
            </Typography>
          </Grid>
          <Grid item style={{  }} >
            {/* <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={{ ...btnStyle2, ...this.textTheme }}>
            <Trans>Reserve</Trans>
          </Button> */}
            <Typography component="h6" className={classes.textBorder} style={{ width:"91px" }} color="error">
              <RemoveIcon color="error" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px", marginRight: "3px" }}></RemoveIcon>
              <span style={{ fontSize: "12px" }}>   <Trans>Zajety</Trans> </span>
            </Typography>
          </Grid>
        </Grid>
        {/* <Typography component="h6" style={{marginLeft: "5px"}} color='primary'>
          <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px" }}></CheckIcon>
          <span style={{fontSize: "12px"}}>  <Trans>wolne</Trans> </span>
        </Typography>
        <Typography component="h6" style={{marginLeft: "5px"}} color="error">
          <RemoveIcon color="error" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px" }}></RemoveIcon>
          <span style={{fontSize: "12px"}}>  <Trans>Zajety</Trans> </span>
        </Typography> */}
        </>
      // <Grid
      //   container
      //   direction="row"
      //   justifyContent="space-between"
      //   alignItems="baseline"
      //   style={{ marginTop: "8px", padding: "0px 5px" }}>
      //   <Grid item style={{ width: "31%", marginRight: "0px"}} >
      //     <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={this.textTheme}>
      //       <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em"}}></CheckIcon>
      //     </Button>
      //   </Grid>
      //   <Grid item style={{ width: "65%", marginRight: "2px"}} >
      //     <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={this.textTheme}>
      //       <Trans>Reserve</Trans>
      //     </Button>
      //   </Grid>
      //   <Grid item style={{ width: "31%", marginRight: "0px"}} >
      //     <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={this.textTheme}>
      //       <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em"}}></CheckIcon>
      //     </Button>
      //   </Grid>
      //   <Grid item style={{ width: "65%", marginRight: "2px"}} >
      //     <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={this.textTheme}>
      //       <Trans>Reserve</Trans>
      //     </Button>
      //   </Grid>
      // </Grid>
    )
  }

  legendMobile = () => {
    const { classes } = this.props;
    let btnStyle1 = { width: this.props.windowWidth > 600 ? "40px" : "50px", } as React.CSSProperties
    let btnStyle2 = { width: this.props.windowWidth > 600 ? "88px" : "108px", } as React.CSSProperties

    //if(this.props.page.podstrona)
    //  return null
    //else
      return (
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="baseline"
          style={{ margin: "8px 0px 0px", padding: "0px 5px" }}>
          <Grid item style={{ marginRight: "3px" }} >
            {/* <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={{ ...btnStyle1, ...this.textTheme }}>
            <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em"}}></CheckIcon>
          </Button> */}
            {/* <Typography component="h6" style={{  }} color='primary'>
              <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px", marginRight: "3px" }}></CheckIcon>
              <span style={{ fontSize: "12px" }}>   <Trans>wolne</Trans> </span>
            </Typography> */}
            <Typography component="h6" className={classes.textBorder} style={{}} color='primary'>
              {this.props.page.serwerWersja >= 5 ?
              <>
              
              {/* <span style={{ fontSize: "12px", marginRight: "3px" }}> 123 </span> */}
              <span style={{ fontSize: "12px", textTransform: "lowercase" }}> <Trans>Prices</Trans> </span>
              </>
              :
              <>
                <CheckIcon color="primary" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px", marginRight: "3px" }}></CheckIcon>
                <span style={{ fontSize: "12px" }}> <Trans>Wolny</Trans> </span>
                </>
              }
            </Typography>
          </Grid>
          <Grid item style={{  }} >
            {/* <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary" style={{ ...btnStyle2, ...this.textTheme }}>
            <Trans>Reserve</Trans>
          </Button> */}
            {/* <Typography component="h6" style={{  }} color="error">
              <RemoveIcon color="error" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px", marginRight: "3px" }}></RemoveIcon>
              <span style={{ fontSize: "12px" }}>   <Trans>Zajety</Trans> </span>
            </Typography> */}
            <Typography component="h6" className={classes.textBorder} style={{}} color="error">
              <RemoveIcon color="error" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-8px", marginRight: "3px" }}></RemoveIcon>
              <span style={{ fontSize: "12px" }}>   <Trans>Zajety</Trans> </span>
            </Typography>
          </Grid>
        </Grid>
    )
  }

  //PM 2021-08-13
  //usuniecie MuiButton-outlinedPrimary
  render() {
    const { classes, t } = this.props;

    let grafikNumeryLength = this.props.page.grafikNumery.filter((x: ObiectRoomNumer) => x.typ === 2).length
    //let grafikRodzajeLenght = this.props.page.grafikRodzaje.filter((x: ObiectRoomRodzaj) => x.typ === 2).length
    //vscTest
    //console.log(this.props.expanded && grafikNumeryLength > 7)

    let diff = String(datediff(new Date(this.props.page.dateFrom), new Date(this.props.page.dateTo)))
		let diffText = (Number(diff) > 1 || Number(diff) === 0  ? " " + t("Days") : " " + t("Day"))

    return (
      <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={setLocale(this.props.page.lang)}>
        {this.props.windowWidth >= 600 ?
          <Fragment>
            {this.props.noFlags ? null : <FlagIcons /> }
            {/* <hr style={{ border: "0", borderBottom: "1px solid rgba(170, 170, 170, 1)", marginTop: "0px" }} /> */}
            <div style={{marginTop: "0px", display: this.props.windowWidth < 1095 ? "flex" : "block", justifyContent: "center"}}>
              {/* <FormLabel component="legend" className={`${classes.formLabel} ${classes.horitzontalMargin}`}>przyjazd</FormLabel> */}

              <Button
                  onClick={() => this.openCalendar()}
                  variant="outlined"
                  //style={{ width: "calc(100% + -3px)", color: "white", color: "#e65100", }}
                  style={{ width: "180px", height: "40px", ...this.textTheme,  marginTop: "0px", marginRight: "-2px" }}
                  className={`${classes.input} ${classes.margin} ${classes.horitzontalMargin} ${classes.dateBorder} ${classes.primary} `}
                  color="primary"
                >
                  {daysFromDate(this.state.fromDate, 0) + "  " + moment.weekdays()[new Date(this.state.fromDate).getDay()]}
                </Button>
                
                <Button
                  onClick={() => this.openCalendar()}
                  variant="outlined"
                  //style={{ width: "calc(100% + -3px)", color: "white", color: "#e65100" }}
                  style={{ width: "180px", height: "40px", ...this.textTheme, marginTop: "0px", marginRight: "3px" }}
                  className={`${classes.input} ${classes.margin} ${classes.horitzontalMargin} ${classes.dateBorder} ${classes.primary} `}
                  color="primary"
                >
                  {daysFromDate(this.state.toDate, 0) + "  " + moment.weekdays()[new Date(this.state.toDate).getDay()]}
                </Button>

                <Button variant="outlined" color="primary" size="small"
                    className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.primary}`}
                    style={{ minWidth: "0", height: "40px", width: "53px", ...this.textTheme,  }} //color: "#e65100"
                    //onClick={() => this.setToday()}
                  >
                    <Trans>{diff + diffText}</Trans>
                  </Button>


               {/* <DatePicker value={this.props.page.dateFrom}
                onChange={this.dateChange}
                onAccept={this.dateAccept}
                format="YYYY-MM-DD dddd"
                showTodayButton
                todayLabel={t("Today")}
                cancelLabel={t("Back")}
                minDate={new Date()}
                
                inputVariant="outlined"
                InputProps={{
                  classes: {
                    input: `${classes.input} ${classes.orange}`,
                    notchedOutline: `${classes.noBorder}`,
                  },
                  style: {  ...this.textTheme, color: "#e65100" }
                }}
                className={`${classes.margin} ${classes.horitzontalMargin} ${classes.dateBorder}`}
                style={{ width: "187.5px", height: "30.4px", marginTop: "0px" }} 
                />  */}

              {/* <Tooltip title={t("Month") + " - 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                <Button variant="outlined" color="primary"
                  className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                  //className={`${classes.dateButton} ${classes.size}`}
                  style={{ marginLeft: "5px", marginRight: "3px" }}
                  onClick={() => this.setLastMonth()}>
                  <ChevronLeftIcon style={{ paddingBottom: "1px" }} />
                </Button>
              </Tooltip> */}

              {/* <DatePicker value={this.props.page.dateFrom}
                onChange={this.dateChange}
                onAccept={this.dateAcceptMonth}
                minDate={new Date()}
                views={['month']}
                format="MMMM yyyy"
                inputVariant="outlined"
               
                InputProps={{
                  color: "primary",
                  notched: true,
                  style: { ...this.textTheme, color: "#e65100" },
                  classes: {
                    input: `${classes.input} ${classes.orange}`,
                    notchedOutline: `${classes.noBorder}`,
                  }
                }}
                className={` ${classes.dateBorder}`}
                style={{ width: "117.5px", height: "30.4px", marginBottom: "8px" }} 
                cancelLabel={t("Back")} /> */}

              {/* <Tooltip title={t("Month") + " + 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                <Button variant="outlined" color="primary"
                  className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                
                  style={{ marginLeft: "3px", marginRight: "5px" }}
                  onClick={() => this.setNextMonth()}>
                  <ChevronRightIcon style={{ paddingBottom: "1px" }} />
                </Button>
              </Tooltip> */}

              {/* <FormLabel component="legend" className={`${classes.formLabel} ${classes.horitzontalMargin}`}>nawiguj</FormLabel> */}

              <Tooltip title={t("Today") + " - 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                <Button variant="outlined" color="primary"
                  className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                  //className={`${classes.dateButton} ${classes.size}`}
                  style={{ marginLeft: "3px", marginRight: "0px" }}
                  onClick={() => this.setDateButton(-1)}>
                  <ChevronLeftIcon style={{ paddingBottom: "1px" }} />
                </Button>
              </Tooltip>

              {/* <Tooltip title={t("Today") + " - 7"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                <Button variant="outlined" color="primary"
                  className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                  //className={`${classes.dateButton} ${classes.size}`}
                  style={{ marginRight: "3px" }}
                  onClick={() => this.setDateButton(-7)}>
                  <KeyboardDoubleArrowLeftIcon style={{ paddingBottom: "1px" }} />
                </Button>
              </Tooltip> */}

              {/* <Button variant="outlined" color="primary" size="small"
                className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.primary} `}
                style={{ width: "50px", minWidth: "50px", height: "40px", ...this.textTheme, color: "#e65100", marginTop: "0px" }}
                // width: "97.1px",
                onClick={() => this.setToday()}
              >
                <Trans>Today</Trans>
              </Button> */}

              {/* <Tooltip title={t("Today") + " + 7"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                <Button variant="outlined" color="primary"
                  className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                  //className={`${classes.dateButton} ${classes.size}`} 
                  style={{ marginLeft: "3px" }}
                  onClick={() => this.setDateButton(7)}>
                  <KeyboardDoubleArrowRightIcon style={{ paddingBottom: "1px" }} />
                </Button>
              </Tooltip> */}

              <Tooltip title={t("Today") + " + 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                <Button variant="outlined" color="primary"
                  className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                  //className={`${classes.dateButton} ${classes.size}`} 
                  style={{ marginLeft: "3px", marginRight: "5px" }}
                  onClick={() => this.setDateButton(1)}>
                  <ChevronRightIcon style={{ paddingBottom: "1px" }} />
                </Button>
              </Tooltip>

              {/* {this.daysPanel()} */}
              

                {/* {this.props.page.serwerWersja >= 5 ?
                <Grid
                  container
                  direction="row"
                  justifyContent="center"
                  alignItems="baseline"
                  style={{ marginTop: "0", marginBottom: "14px" }}>
                  <Grid item style={{ marginRight: "3px" }} >
                    <Button variant="outlined" color="primary" size="small"
                      className={`${classes.input} ${classes.dateBorder} ${classes.primary} `}
                      style={{ width: "50px", minWidth: "92.6px", height: "30px", ...this.textTheme, color: "#e65100", marginTop: "0px" }}
                      onClick={() => this.setGrafikMode(0)}
                    >
                      <MeetingRoomIcon color="primary" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-1px", marginRight: "3px", color: theme.palette.primary.main }}></MeetingRoomIcon>
                      <span style={{ fontSize: "12px", textTransform: 'lowercase', color: theme.palette.primary.main }}>   <Trans>Rooms</Trans> </span>
                    </Button>
                  </Grid>
                  <Grid item style={{}} >
                    <Button variant="outlined" color="primary" size="small"
                      className={`${classes.input} ${classes.dateBorder} ${classes.primary} `}
                      style={{ width: "50px", minWidth: "92.6px", height: "30px", ...this.textTheme, color: "#e65100", marginTop: "0px" }}
                      onClick={() => this.setGrafikMode(1)}
                    >
                      <PaidIcon color="primary" style={{ ...this.textTheme, width: "0.6em", marginBottom: "-1px", marginRight: "3px", color: theme.palette.primary.main }}></PaidIcon>
                      <span style={{ fontSize: "12px", textTransform: 'lowercase', color: theme.palette.primary.main }}>   <Trans>Prices</Trans> </span>
                    </Button>
                  </Grid>
                </Grid> : null} */}

              {/* {this.legend()} */}
              
              {/* <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary"
               style={{position: "absolute", bottom: "12px", right: "18px"}}
               onClick={() => this.props.expand()}>
               {'...'}
             </Button> */}
              {/* {this.props.page.roomsOld.length > 7 || this.props.page.rooms.length > 7 || grafikNumeryLength > 7 ?
                this.props.expanded ?
                  <KeyboardArrowUpIcon className={classes.arrow}
                    onClick={() => this.props.expand()} />
                  :
                  <KeyboardArrowDownIcon className={classes.arrow}
                    onClick={() => this.props.expand()} /> : null} */}
            </div>
          </Fragment>

          :
          <Fragment>

            {this.props.noFlags ? null : <FlagIconsOld /> }
            {/* <hr style={{ border: "0", borderBottom: "1px solid rgba(170, 170, 170, 1)", marginTop: "0px" }} /> */}
            <div>


              <Grid
                container
                direction="row"
                justifyContent="center"
                style={{width: "calc(100% + 12px)", marginLeft: "-6px", marginTop: "8px"}}>

               
                <Button
                  onClick={() => this.openCalendar()}
                  variant="outlined"
                  //style={{ width: "calc(100% + -3px)", color: "white",  color: "#e65100", }}
                  style={{ width: "140px", height: "40px", ...this.textTheme, marginTop: "0px", marginRight: "3px" }}
                  className={`${classes.input} ${classes.margin}  ${classes.dateBorder} ${classes.primary} `}
                  color="primary"
                >
                  {daysFromDate(this.state.fromDate, 0) + "  " + moment.weekdays()[new Date(this.state.fromDate).getDay()]}
                </Button>

                <Button
                  onClick={() => this.openCalendar()}
                  variant="outlined"
                  //style={{ width: "calc(100% + -3px)", color: "white", color: "#e65100", }}
                  style={{ width: "140px", height: "40px", ...this.textTheme, marginTop: "0px", marginRight: "3px" }}
                  className={`${classes.input} ${classes.margin}  ${classes.dateBorder} ${classes.primary} `}
                  color="primary"
                >
                  {daysFromDate(this.state.toDate, 0) + "  " + moment.weekdays()[new Date(this.state.toDate).getDay()]}
                </Button>

                <Button variant="outlined" color="primary" size="small"
                    className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.primary}`}
                    style={{ minWidth: "0", height: "40px", width: "53px", ...this.textTheme, }}
                    //onClick={() => this.setToday()}
                  >
                    <Trans>{diff + diffText}</Trans>
                  </Button>

                  {/* <DatePicker value={this.props.page.dateFrom}
                    onChange={this.dateChange}
                    onAccept={this.dateAccept}
                    format="YYYY-MM-DD dddd"
                    showTodayButton
                    todayLabel={t("Today")}
                    cancelLabel={t("Back")}
                    minDate={new Date()}
                    
                    inputVariant="outlined"

                    InputProps={{
                      classes: {
                        input: `${classes.input} ${classes.orange}`,
                        notchedOutline: `${classes.noBorder}`,
                      },
                      style: {  ...this.textTheme, color: "#e65100" }
                    }}
                    className={`${classes.margin} ${classes.dateBorder}`}
                    style={{ width: "140px" }}
                     /> */}
              
                {/* <Tooltip title={t("Month") + " - 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                  <Button variant="outlined" color="primary"
                    className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                    
                    style={{ marginLeft: "6px", marginRight: "3px" }}
                    onClick={() => this.setLastMonth()}>
                    <ChevronLeftIcon style={{ paddingBottom: "1px" }} />
                  </Button>
                </Tooltip>
                
                  <DatePicker value={this.props.page.dateFrom}
                    onChange={this.dateChange}
                    onAccept={this.dateAcceptMonth}
                    minDate={new Date()}
                    views={['month']}
                    format="MMMM yyyy"
                    inputVariant="outlined"
                    
                    InputProps={{
                      color: "primary",
                      notched: true,
                      style: {  ...this.textTheme, color: "#e65100", },
                      classes: {
                        input: `${classes.input} ${classes.orange}`,
                        notchedOutline: `${classes.noBorder}`,
                      }
                    }}
                    className={`${classes.margin} ${classes.dateBorder}`}
                    style={{ width: "100px" }} 
                    cancelLabel={t("Back")}/>
                
                <Tooltip title={t("Month") + " + 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                  <Button variant="outlined" color="primary"
                    className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.nav}`}
                    
                    style={{ marginLeft: "3px", marginRight: "3px" }}
                    onClick={() => this.setNextMonth()}>
                    <ChevronRightIcon style={{ paddingBottom: "1px" }} />
                  </Button>
                </Tooltip> */}
                
              <div style={{display: "inline-block"}}>
                
                  <Tooltip title={t("Today") + " - 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                    <Button variant="outlined" color="primary"
                      className={`${classes.input} ${classes.dateBorder} ${classes.nav} ${classes.margin}`}
                      //className={`${classes.dateButton} ${classes.size}`} 
                      style={{ marginLeft: "3px", marginRight: "3px" }}
                      onClick={() => this.setDateButton(-1)}>
                      <ChevronLeftIcon style={{ paddingBottom: "1px" }} />
                    </Button>
                  </Tooltip> 
                
                  {/* <Tooltip title={t("Today") + " - 7"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                    <Button variant="outlined" color="primary"
                      className={`${classes.input} ${classes.dateBorder} ${classes.nav} ${classes.margin}`}
                      //className={`${classes.dateButton} ${classes.size}`} 
                      style={{ marginRight: "3px" }}
                      onClick={() => this.setDateButton(-7)}>
                      <KeyboardDoubleArrowLeftIcon style={{ paddingBottom: "1px" }} />
                    </Button>
                  </Tooltip>  */}
                
                  {/* <Button variant="outlined" color="primary" size="small"
                    className={`${classes.input} ${classes.margin} ${classes.dateBorder} ${classes.primary}`}
                    style={{ minWidth: "0", height: "40px", width: "53px", ...this.textTheme, color: "#e65100" }}
                    onClick={() => this.setToday()}
                  >
                    <Trans>Today</Trans>
                  </Button> */}
                
                  {/* <Tooltip title={t("Today") + " + 7"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                    <Button variant="outlined" color="primary"
                      className={`${classes.input} ${classes.dateBorder} ${classes.nav} ${classes.margin}`}
                      //className={`${classes.dateButton} ${classes.size}`} 
                      style={{ marginLeft: "3px", marginRight: "3px" }}
                      onClick={() => this.setDateButton(7)}>
                      <KeyboardDoubleArrowRightIcon style={{ paddingBottom: "1px" }} />
                    </Button>
                  </Tooltip>  */}
                
                  <Tooltip title={t("Today") + " + 1"} arrow classes={{ tooltip: classes.tooltip, arrow: classes.tooltipArrow }}>
                    <Button variant="outlined" color="primary"
                      className={`${classes.input} ${classes.dateBorder} ${classes.nav} ${classes.margin}`}
                      //className={`${classes.dateButton} ${classes.size}`} 
                      style={{ marginLeft: "0px", marginRight: "3px" }}
                      onClick={() => this.setDateButton(1)}>
                      <ChevronRightIcon style={{ paddingBottom: "1px" }} />
                    </Button>
                  </Tooltip>  
                
              </div>  


              </Grid>
              {/* {this.daysPanelMobile()} */}
              {/* {this.legendMobile()} */}
              {/* <Button className={`${classes.button} ${classes.dateBorder}`} variant="outlined" color="primary"
               style={{position: "absolute", bottom: "12px", right: "18px"}}
               onClick={() => this.props.expand()}>
               {'...'}
             </Button> */}
            </div>
          </Fragment>}
          <Calendar opened={this.state.openCalendar} accept={this.acceptCalendar} close={this.closeCalendar} dateFrom={daysFromDate(this.state.fromDate, 0)} dateTo={daysFromDate(this.state.toDate, 0)} windowWidth={this.props.windowWidth} />
      </MuiPickersUtilsProvider>
    );
  }
}


const styles = (theme: Theme) => ({
  container: {
    marginTop: "12px"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  //PM 2021-03-18
  primary: {
    //color: "seagreen"
    color: theme.palette.primary.main,
    //ks 2021-02-18 było color: '#b63b4d'   
    //color: '#732222'
    //PM 2021-03-18 było color: '#732222' 
  },
  orange: {
    //color: "rgb(236, 100, 48)"
    //color: "crimson"
    color: "#e65100"
    //color: theme.palette.primary.main,
  },
  input: {
    fontSize: "11px",
    fontFamily: "\"Arial\", \"Helvetica\", sans-serif",
    lineHeight: "20px",
    fontWeight: "bold" as "bold",
    textTransform: "lowercase" as "lowercase",
    height: "14px",
    padding: "8px 2px",
    borderRadius: "0px"
  },
  text: {
    color: theme.palette.text.primary
  },
  button: {
    fontSize: "11px",
    height: "30px",
    minWidth: "30px",
    //width: "36px",
    width: "100%",
    textTransform: "none" as "none",
    //fontWeight: "bold" as "bold",
    padding: "5px",
    borderRadius: "0px"
  },
  marginSmall: {
    marginTop: "4px",
    marginBottom: "4px",

  },
  margin: {
    //marginTop: "4px",
    //marginBottom: "4px",
    marginTop: "0px",
    marginBottom: "8px",
  },
  horitzontalMargin: {
    marginLeft: '5px',
    marginRight: '5px'
  },
  dateBorder: {
    borderStyle: "solid",
    borderWidth: "1px",
    //borderColor: theme.palette.primary.main,
    ///borderColor: "lightgrey",
    borderColor: "lavender",

    borderRadius: "0px",
    //borderRadius: "4px",
    "&:hover": {
      //borderRadius: "4px",
      borderRadius: "0px",
      borderColor: theme.palette.primary.dark,
      backgroundColor: 'rgba(69, 139, 0, 0.04)',
    },
  },
  noBorder: {
    borderWidth: "0px !important",
    borderRadius: "0px",
    borderColor: "white",
    "&:hover": {
      borderRadius: "0px",
      borderColor: 'white',
      backgroundColor: 'white',
    },
  },
  arrow: {
    cursor: "pointer",
    color: theme.palette.primary.main,
    //padding: "4px",
    position: 'absolute' as 'absolute',
    //bottom: '8px',
    bottom: '4px',
    //right: '78px',
    right: '66px',
    width: '60px',
    fontSize: '40px'
  },
  today: {
    minWidth: "0",
    fontSize: "1rem",
    //width: "40px", 
    height: "35px",
    //padding: "3px 5px 0px",
    color: theme.palette.primary.main,
    textTransform: "lowercase" as "lowercase",
    letterSpacing: "0px"
  },
  formLabel: {
    fontSize: "10px",
    fontWeight: "bold" as "bold",
    color: theme.palette.primary.main,
    paddingBottom: "3px",
  },
  nav: {
    padding: "0",
    width: "32px",
    height: "40px",
    minWidth: "0",
    marginTop: "0",
    color: "lavender",
    //color: "rgb(230, 81, 0)"
     "&:hover": {
      color: theme.palette.primary.light,
    },
  },
    navSmall: {
      padding: "0",
      width: "30px",
      height: "40px",
      minWidth: "0",
      marginTop: "0",
      color: "lavender",
      //color: "rgb(230, 81, 0)"
       "&:hover": {
        color: theme.palette.primary.light,
      },
  },
  textBorder: {
    border: "1px solid lavender",
    width: "80.8px",
    textAlign: "center" as "center",
    height: "28.4px",
  },
  tooltip: {
    fontSize: "10px",
    color: "#3a87ad",
    background: "yellow"
},
tooltipArrow: {
    color: "yellow"
},

});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});


export default connect(mapStateToProps)(withTranslation()(withStyles(styles)(DatePickers)));
